export default "__VITE_ASSET__CCMBh1oB__"